import request, { authOptions } from 'api/requestUtils'
import config from 'constants/config'
import { isRecord } from 'lib/object/objectUtils'

const EVALUATE_PATH = '/api/lab/v2/evaluate'
const EVALUATE_TIMEOUT_MS = 1000

/**
 * Config payloads keyed by name, the same shape Lab v1 remote config is read by.
 * Undefined when the call is skipped, fails, or the body is not an evaluate result.
 */
export async function evaluateLabV2(
  token: string | undefined,
  enabled: boolean,
  attributes: Record<string, string>,
): Promise<Record<string, unknown> | undefined> {
  if (!enabled || !config.LAB_V2_ENABLED) {
    return undefined
  }

  try {
    const body = await request.post<unknown, { attributes: Record<string, string> }>(
      EVALUATE_PATH,
      { attributes },
      {
        ...authOptions(token),
        timeout: EVALUATE_TIMEOUT_MS,
        // The evaluate body only allows `attributes`. This keeps the shared client from adding `brand`.
        excludeBrand: true,
      },
    )
    return configsByName(body)
  } catch {
    // The document still renders when Lab v2 is down or slow.
    return undefined
  }
}

function configsByName(body: unknown): Record<string, unknown> | undefined {
  if (!isRecord(body) || !isRecord(body.result) || !Array.isArray(body.result.configs)) {
    return undefined
  }

  const configs: Record<string, unknown> = {}
  for (const config of body.result.configs) {
    if (!isRecord(config) || typeof config.name !== 'string' || config.name.length === 0) {
      continue
    }
    if (!(config.name in configs)) {
      configs[config.name] = config.payload
    }
  }
  return configs
}
